<template>
  <ModalDialog
    ref="dialog"
    title="Send Purchase Order"
    :submitting="submitting"
    :scrollable="true"
    :submitDisabled="currentlyUploading"
    submitTitle="Send"
    icon="fa-dolly-flatbed"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm">
      <EmailMessageForm 
        :contactId="supplierContactId"
        :templateType="MessageTemplateTypes.purchaseOrder"
        :messageTemplateUpdateFn="messageTemplateUpdateFn"
        :previewLink="previewLink"
        @uploading="currentlyUploading = $event"
        @update="emailDetails = $event"
      />
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import EmailMessageForm from '@/modules/core/components/emailMessageForm'

import { MessageTemplateTypes, CommunicationMethodTypes } from '@/store/types'

export default {
  name: 'SendExternalPurchaseOrderDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
    EmailMessageForm
  },
  props: {
    orderId: Number,
    purchaseOrderId: Number,
    supplierContactId: Number
  },
  data() {
    return {
      dialogForm: {},
      messageTemplateUpdateFn: this.getMessageTemplateUpdatePromise,
      emailDetails: { },
      submitting: false,
      currentlyUploading: false
    }
  },
  created() {
    this.MessageTemplateTypes = MessageTemplateTypes
  },
  mounted() {
  },
  computed: {
    previewLink() {
      return `/purchasing/purchaseorders/${this.purchaseOrderId}/report`
    }
  },
  methods: {
    show() {
      // Reset form
      this.responseInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      // Send email flags for contact persons to email
      var orderEmailData = {
        messageSubject: this.emailDetails.messageSubject,
        messageContent: this.emailDetails.messageContent,
        emailPersonList: this.emailDetails.contactPersonList.map(person => { return {contactPersonId: person.id } }),
        uploadFileList: this.emailDetails.uploadFileList,
        ccList: this.emailDetails.ccList
      }

      this.$apiService.ordersService.externalPurchaseOrderSend(this.orderId, this.purchaseOrderId, orderEmailData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    getMessageTemplateUpdatePromise(messageTemplateId) {
      return new Promise((resolve, reject) => {
        return this.$apiService.purchasingService.getPurchaseOrderApprovalTemplate(this.purchaseOrderId, messageTemplateId)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>